const getToken = () => {
    const userToken = localStorage.getItem("token");
    return(
        userToken
    )
}

export default getToken